import LeftTextSection from "../components/LeftTextSection";

export default function Story() {
  return (
    <>
      <div className="bg-gray-light">
        <div className="m-auto max-w-[1124px]">
          <LeftTextSection />
        </div>
      </div>
    </>
  );
}
